import FfFileInput from './ff-file-input';

export default FfFileInput;
